import React, { useState } from 'react'
import { Button, Select } from '@ow/comps'
import nulldata from './assets/nulldata.png'

/**
 * 无绑定表单时，显示默认图及表单选择下拉
 * @param {*} props
 * @returns
 */
const EmptyWithTbSelect = (props) => {
  const { tbs, onTbSelect } = props
  const [selectedId, setSelectedId] = useState()
  const render = () => {
    const renderTbSelect = () => {
      const options = []
      Object.values(tbs).reduce((pre, cur) => {
        if (
          cur.enableStandardBind &&
          !options.find((item) => item.id === cur.tbId)
        ) {
          pre.push({
            label: cur.tbName,
            id: cur.tbId,
          })
        }
        return pre
      }, options)
      return (
        <div className="flex w-full pl-5">
          <Select
            options={options || []}
            className="mr-3 w-[240px]"
            onChange={(e) => {
              const { id } = e
              setSelectedId(id)
            }}
            placeholder="选择表单"
            noOptionsMessage={() => '暂无数据'}
            allowClear={false}
          />
          <Button
            type="primary"
            onClick={() => {
              if (onTbSelect) {
                onTbSelect(selectedId)
              }
            }}
          >
            开始添加
          </Button>
        </div>
      )
    }
    return (
      tbs && (
        <div className="flex items-center justify-center flex-col gap-6 h-full">
          <img
            src={nulldata}
            alt="nulldata"
            className="w-[300px] h-[260px] mt-[-80px]"
          />
          <div className="text-sm text-center">
            暂无关联表单属性信息，您可以【选择表单】后开始添加
          </div>
          <div className="mx-auto">{renderTbSelect()}</div>
        </div>
      )
    )
  }
  return render()
}

export default EmptyWithTbSelect
